import React from "react";
import { cn, tinaField } from "@/lib/utils";
import Section from "@/components/Section";
import Pill from "@/components/Pill";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import TextTooltip from "@/components/TextTooltip";

export default function FAQs({ faqs, wrapperClassName, isSection = false }) {
  return (
    <Section
      wrapperClassName={cn("!pb-24", wrapperClassName, {
        "bg-background-purplish": isSection,
      })}
      className="flex flex-col gap-12 items-center"
    >
      {isSection && (
        <div className="flex flex-col items-center gap-6">
          <Pill data-tina-field={tinaField(faqs, "sectionTitle")}>
            {faqs?.sectionTitle}
          </Pill>
          <h2 className="h2" data-tina-field={tinaField(faqs, "title")}>
            {faqs?.title}
          </h2>
          <TextTooltip
            text={faqs?.description}
            className="p-lg text-foreground-300"
            data-tina-field={tinaField(faqs, "description")}
          />
        </div>
      )}

      <Accordion
        type="single"
        collapsible
        defaultValue="item-0"
        className="max-w-[800px] w-full"
      >
        {faqs?.questions?.map((item, index) => (
          <AccordionItem
            key={index}
            value={`item-${index}`}
            className="!border-b border-foreground-600 w-full"
          >
            <AccordionTrigger className="p-lg font-medium hover:no-underline cursor-pointer hover:text-primary-300 hover:[&>svg]:text-primary-300 hover:[&>svg]:bg-background-blackish py-6 x w-full [&>svg]:border [&>svg]:border-primary-500 [&>svg]:p-2 [&>svg]:rounded-full [&>svg]:text-white [&>svg]:size-9 [&[data-state=open]>svg]:rotate-0 [&[data-state=open]>svg>path:nth-child(2)]:hidden [&[data-state=open]>svg]:bg-background-blackish [&[data-state=open]>svg]:text-primary-300 [&[data-state=open]>svg]:rounded-full">
              <span
                className="flex-1 min-h-2"
                data-tina-field={tinaField(faqs, `questions.${index}.question`)}
              >
                {item.question}
              </span>
            </AccordionTrigger>
            <AccordionContent
              data-tina-field={tinaField(faqs, `questions.${index}.answer`)}
            >
              <TextTooltip
                text={item.answer}
                className="p-lg text-foreground-300"
              />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Section>
  );
}
